import React, { useState } from 'react';
import ResearchForm from './ResearchForm';
import AddPlacesModal from './AddPlacesModal';
import Places from './Places';
import './styles.scss';
function Research() {
    const [addPlaces, setAddPlaces] = useState(false);

    return (
        <>
            <div className="research-management">
                <div className="row header">
                    <h1 className="">Research Management</h1>
                    <button
                        onClick={() => setAddPlaces(!addPlaces)}
                        className="btn btn-custom btn-lg mt-3"
                    >
                        + Create Project
                    </button>
                </div>
                <AddPlacesModal
                    open={addPlaces}
                    handleClose={() => setAddPlaces(false)}
                />
                <ResearchForm />
                <Places />
            </div>
        </>
    );
}

export default Research;
